<input #checkbox
  type="checkbox"
  class="form-check-input"
  [id]="inputId"
  [name]="name"
  [value]="checked"
  [checked]="checked"
  [disabled]="disabled"
  [readonly]="readonly"
  [tabindex]="tabindex"
  (change)="onChange($event)"
  (blur)="onBlur($event)" />
<label
  *ngIf="label"
  [for]="inputId"
  [ngClass]="labelClasses"
  class="form-check-label">
  <span>{{label | translate}}</span>
</label>
